[
  {
    "id": "SWW-M6-L103-001",
    "module": "SpellingWW",
    "difficulty": 103,
    "difficultyTier": 3,
    "levelCode": "M6",
    "group": 6,
    "question": "Gisteren ... hij het huiswerk. (maken)",
    "options": ["maakte", "maakt", "maakten", "gemaakt"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verleden_tijd",
    "subSkill": "vt_enkelvoud_context",
    "familyId": "SWW-VT-ZWAK-ENKELVOUD",
    "conceptId": "past_tense_singular_basic",
    "variantIndex": 1,
    "explanation": "Door 'gisteren' kies je verleden tijd. Onderwerp is 'hij' (enkelvoud), dus: maakte.",
    "distractorExplanations": {
      "1": "Dit is tegenwoordige tijd. 'Gisteren' vraagt verleden tijd.",
      "2": "Dit is meervoud verleden tijd (wij maakten). Hier is het enkelvoud: hij maakte.",
      "3": "Dit is het voltooid deelwoord en hoort met 'heeft': 'hij heeft gemaakt'."
    }
  },
  {
    "id": "SWW-M6-L103-002",
    "module": "SpellingWW",
    "difficulty": 103,
    "difficultyTier": 3,
    "levelCode": "M6",
    "group": 6,
    "question": "Wij ... gisteren een spel. (spelen)",
    "options": ["speelden", "speelde", "spelen", "gespeeld"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verleden_tijd",
    "subSkill": "vt_meervoud_context",
    "familyId": "SWW-VT-MEERVOUD-CONTEXT",
    "conceptId": "past_tense_plural_context",
    "variantIndex": 1,
    "explanation": "Door 'gisteren' is het verleden tijd. Onderwerp is 'wij' (meervoud). Dan krijg je: speelden.",
    "distractorExplanations": {
      "1": "Dit is verleden tijd enkelvoud (hij speelde). Bij 'wij' moet het meervoud zijn: speelden.",
      "2": "Dit is het hele werkwoord. Je hebt de persoonsvorm nodig: speelden.",
      "3": "Dit is het voltooid deelwoord en hoort met 'hebben': 'wij hebben gespeeld'."
    }
  },
  {
    "id": "SWW-M6-L103-003",
    "module": "SpellingWW",
    "difficulty": 103,
    "difficultyTier": 3,
    "levelCode": "M6",
    "group": 6,
    "question": "Het raam is ... (wassen).",
    "options": ["gewassen", "gewast", "waste", "wast"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_na_is",
    "familyId": "SWW-VD-STERK-BASIS",
    "conceptId": "past_participle_strong_basic",
    "variantIndex": 1,
    "explanation": "Na 'is' hoort een voltooid deelwoord. Van 'wassen' is dat: gewassen.",
    "distractorExplanations": {
      "1": "Dit lijkt op 't kofschip, maar 'wassen' is geen zwak werkwoord met -d of -t. Het juiste voltooid deelwoord is: gewassen.",
      "2": "Dit is verleden tijd (ik waste). Na 'is' gebruik je een voltooid deelwoord.",
      "3": "Dit is tegenwoordige tijd (hij wast). Na 'is' hoort een voltooid deelwoord."
    }
  },
  {
    "id": "SWW-M6-L103-004",
    "module": "SpellingWW",
    "difficulty": 103,
    "difficultyTier": 3,
    "levelCode": "M6",
    "group": 6,
    "question": "Hij ... de bal hard. (schoppen)",
    "options": ["schopt", "schop", "schopte", "geschopt"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tegenwoordige_tijd",
    "subSkill": "pv_hij_zij_het_stam_plus_t",
    "familyId": "SWW-TT-HIJ-ZIJ-HET-STAM_PLUS_T",
    "conceptId": "present_tense_third_person_add_t",
    "variantIndex": 2,
    "explanation": "Onderwerp is 'hij', dus stam + t. Stam van 'schoppen' is 'schop'. Schop + t = schopt.",
    "distractorExplanations": {
      "1": "Dit is de ik-vorm: ik schop. Bij 'hij' hoort schopt.",
      "2": "Dit is verleden tijd. In de zin gaat het om wat hij nu doet.",
      "3": "Dit is het voltooid deelwoord en hoort met 'heeft': hij heeft geschopt."
    }
  },
  {
    "id": "SWW-M6-L103-005",
    "module": "SpellingWW",
    "difficulty": 103,
    "difficultyTier": 3,
    "levelCode": "M6",
    "group": 6,
    "question": "De koekjes zijn ... (pakken).",
    "options": ["gepakt", "gepakd", "pakten", "pakt"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_zwak_tkofschip",
    "familyId": "SWW-VD-ZWAK-TKOF-KEUZE",
    "conceptId": "past_participle_weak_t_rule",
    "variantIndex": 1,
    "explanation": "Na 'zijn' hoort een voltooid deelwoord.\nHele werkwoord: pakken. Stam: pak.\nLaatste letter is k (zit in 't kofschip), dus het voltooid deelwoord eindigt op t: gepakt.",
    "distractorExplanations": {
      "1": "Je kiest d, maar k zit in 't kofschip. Daarom moet het t zijn: gepakt.",
      "2": "Dit is verleden tijd meervoud (wij pakten). Na 'zijn' moet een voltooid deelwoord staan.",
      "3": "Dit is tegenwoordige tijd (hij pakt). Na 'zijn' hoort een voltooid deelwoord."
    }
  }
]
